import React, { ReactNode } from "react";

interface ConfirmPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
  message?: ReactNode;
  btnColor?: string;
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  onConfirm,
  onCancel,
  message,
  btnColor = "red",
}) => {
  return (
    <>
      <div className="background-mask" onClick={() => onCancel()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onCancel()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <div>{message || "Are you sure you want to proceed?"}</div>
        </div>
        <div className="filter-actions">
          <button className={`oxbtn btn-${btnColor}`} onClick={onConfirm}>
            Yes, I'm Sure
          </button>
          <button className="oxbtn btn-grey" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmPopup;
